<div class="agent-card-container pointer" (click)="toggleMenu($event)">
    <div class="agent-card">
        <div class="agent-image-col">
            <img [src]="agent.profileImage || './assets/images/icons/user-default-icon.png'" [alt]="agent.firstName" class="agent-image" [class.full]="agent.profileImage" (error)="setDefaultImage($event)">
        </div>

        <div class="agent-content-col">
            <div class="col-header">
                <h3 class="agent-title">{{ agent.firstName + " " + agent.lastName }}</h3>
                <div class="right-side">
                    <div class="status-badge">
                        <span class="status-dot" [class.public]="agent.isAvailable" [class.private]="!agent.isAvailable"></span>
                        <span class="status-text">{{ agent.isAvailable ? 'Disponible' : 'Indisponible' }}</span>
                    </div>
                    <div class="status-badge">
                        <span class="status-dot" [class.public]="agent.isEnabled" [class.private]="!agent.isEnabled"></span>
                        <span class="status-text">{{ agent.isEnabled ? 'Compte activer' : 'Compte Désactiver' }}</span>
                    </div>
                    <div *ngIf="agent.rating" class="rating">
                        <div class="rating-stars">
                            @for (star of getStars(agent.rating); track $index) {
                            <img [src]="star" alt="star" class="star"> }
                        </div>
                        <span>{{agent.rating}}/5</span>
                    </div>
                    <button class="card-menu-btn" type="button" (click)="toggleMenu($event)">
                        <img src="./assets/images/icons/menu-drop.png" alt="menu" class="menu-icon">
                    </button>
                </div>
            </div>

            <div class="agent-footer">
                <div class="agent-info">
                    <span class="agent-email">{{ agent.email }}</span>
                    <span class="agent-email">{{ agent.phoneNumber }}</span>
                    <span class="agent-email">{{ agent.age }} ans</span>
                    <span class="agent-email">{{ agent.height }} cm</span>
                </div>
                <div class="creation-date">
                    {{ agent.createdAt }}
                </div>
            </div>
        </div>
    </div>

    <div class="popup-menu" *ngIf="menuOpen">
        <div class="arrow"></div>
        <ul>
            <li (click)="details()">
                <img src="./assets/images/icons/details.png" alt="View"> Détails
            </li>
            <li (click)="edit()">
                <img src="./assets/images/icons/edit.png" alt="View"> Modifier
            </li>
            <li (click)="toggleVisibility()">
                <img class="lock" src="./assets/images/icons/lock-red.png" alt="Visibility"> {{ agent.isEnabled ? 'Désactiver le compte' : 'Activer le compte' }}
            </li>
            <li (click)="confirmDelete()" class="delete-item">
                <img src="./assets/images/icons/trash.png" alt="Delete"> Supprimer
            </li>
        </ul>
    </div>
</div>

<div class="confirmation-modal-overlay" *ngIf="showDeleteModal">
    <div class="confirmation-modal">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer la suppression</h3>
            <button class="close-button" (click)="closeDeleteModal()">×</button>
        </div>
        <div class="modal-body">
            <p>Êtes-vous sûr de vouloir supprimer ce agent <br><strong>"{{ agent.firstName + " " + agent.lastName  }}"</strong> (<small>{{agent.email}}</small>) ?</p>
            <p class="warning-text">Cette action est irréversible.</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeDeleteModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="deleteAgent()">Supprimer</button>
        </div>
    </div>
</div>